import React, { useEffect, useState } from "react";
import Decrement from "../images/increment.svg";
import Increment from "../images/decrement.svg";
import axios from "axios";
import { baseURL } from "../constants/Api";
import Skeleton from "./skeletons/skeleton";
import ButtonLoader from "./loaders/ButtonLoader";
import BackButton from "../pages/bars/BackButton";
import { checkPastTime, checkPastTimeAndMinMaxTime, fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo, validatePhoneNumber } from "../utils/util";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { SpaServiceSubmitButtonClick } from "../utils/Analytics";
function SpaForm(props) {

  const navigate = useNavigate();
  const location = useLocation();
  const start_time =props.spaData.start_time; // Convert string to Dayjs
  const maxTime = props.spaData.close_time;
  const RateFromPromotion = props.Rate?props.Rate:"";
  console.log("RateFromPromotion============",RateFromPromotion)
  // console.log("start_time==================",start_time)
  // console.log("close_time==================",maxTime)
  const spaId = location?.state?.spadata?.spaId ||props.spaId;
  const spaServiceId = location?.state?.spadata?.spaServiceId || props.spaData.id;
  const promotionId = location?.state?.spadata?.promotionId || props?.promotionId;
  const gst = location?.state?.spadata?.gst || props?.spaData?.gst;
  const hotelId = localStorage.getItem("hotel-id");
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const guestId = localStorage.getItem("guestId");
  const [noOfPeople, setNoOfPeople] = useState(location?.state?.spadata?.noOfPeople || 1);
  const storedData = fetchRoomNoAndPhoneNo();

  const [roomNumber, setRoomNumber] = useState(storedData?.room);
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const [date, setDate] = useState(location.state?.spadata?.bookingDate?.split(" ")[0] || `${year}-${month}-${day}`);
  const initialDate = `${year}-${month}-${day}`;
  const [time, setTime] = useState(`${hours}:${minutes}:${seconds}`);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timeisValid, settimeisValid] = useState(false);
  const [errorMsg, setErrorMsgValue] = useState("");
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  var datetime = new Date(reservationData.dateOut);
  var date_out = datetime.toISOString().split("T")[0];
  const today = dayjs().format('YYYY-MM-DD');
  const currentHour = dayjs().hour();
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const [mobileNo, setMobileNo] = useState(location?.state?.spadata?.contactNumber || (storedData?.phone ? storedData?.phone : localStorage.getItem("phone_no")));
  const [mobileValidation, setMobileValidation] = useState(true);

  const spaDate = location.state?.spadata?.bookingDate;
  let parsedDate = null;
  if(spaDate){
    parsedDate =  dayjs(spaDate)
  
    const details = spaDate
        ? {
              $L: 'en',
              $u: undefined,
              $d: parsedDate.toDate(), // JavaScript Date object
              $y: parsedDate.year(),
              $M: parsedDate.month(), // Month (0-indexed: December = 11)
              $date: parsedDate.date(), // Day of the month
          }
        : {};
  }
  

  const [timeValue, setTimeValue] = useState(parsedDate || null )
  const [selectedTime, setSelectedTime] = useState( location.state?.spadata?.bookingDate?.split(" ")[1] || ""); // State to hold the selected time



  const handleRoomNo = (e) => {
    setRoomNumber(e.target.value);
    setError("");
  };

  const handleIncrment = () => {
    setNoOfPeople((prev) => parseInt(prev || 0) + 1);
    setError("");
  };

  const handleDecrment = () => {
    setError("");
    if (noOfPeople > 1) {
      setNoOfPeople((prev) => Math.max(0, parseInt(prev || 0) - 1));
    }
  };
  const handleOccupancyChange = (event) => {
    setError("");
    const value = event.target.value;
    if (value === "0") {
      // setError("Occupancy cannot be 0. Please enter a valid value.");
      return; 
    }
    if (/^\d*$/.test(value)) {
      setNoOfPeople(value); 
    }
  };



  const handleTimeChange = (newValue) => {
    if (newValue) {
      const formattedTime =  dayjs(newValue).format('HH:mm:ss'); // Format the time to 'HH:mm:ss'
      console.log(newValue, formattedTime, "ddd")
      setTimeValue(newValue);
      setSelectedTime(formattedTime);
    } else {
      setSelectedTime(''); // Handle case when no valid time is selected
    }
  };
  // console.log("time=================", time)
  const minTime = currentHour >= 12 ? dayjs().hour(12).minute(0) : dayjs().hour(8).minute(0);
  const handleDate = (e) => {
    setDate(e.target.value);
    setTime(null);
  };
  // console.log("time======= 11111111===============", selectedTime)
  const handleSubmit = (e) => {
    console.log(":")
    setError("");
    setErrorMsgValue("");
    e.preventDefault();
   let workingTimeCheck = '';
    if(selectedTime !== ''){
      workingTimeCheck = checkPastTimeAndMinMaxTime(date, selectedTime,start_time,maxTime);
    }
    if (roomNumber === "" && isCheckedIn == "true") {
      setError("validation");
    }else if (!mobileValidation && isCheckedIn != "true") {
      setErrorMsgValue("Please give mobile number");
     }
    else if (selectedTime === '' ) {
      setError("timeIsnotSelect");
    } else if(workingTimeCheck === true){
      setError("timeCheck");
    }else if(date === ''){
      setError("dateError");
    }else if(noOfPeople == ''){
      setError("OccupancyError");
    } else {
      console.log("bookTable in ");
      SpaServiceSubmitButtonClick();
      bookTable();
      // console.log("date=============",date);
    }
  };

  const bookTable = async () => {
     
      console.log("objectsss")
      console.log(promotionId, props)
      var data = {
        hotelId,
        spaId,
        roomNumber,
        guestId,
        reservationId,
        spaServiceId,
        date: `${date} ${selectedTime}`,
        noOfPeople,
        appUserId,
        gst,
        promotionId,
        contactNumber: mobileNo
      };

      let url ="";
      let method = "";

      if (location.state?.spadata) {
        data.spaBookingId =location?.state?.spadata?.id;
        url = '/api/spaBookingUpdateV21'
        method ="put"
        console.log("editttttttttttttttttt")
      }else{
        url = '/api/spaV21'
        method ="post"
        console.log("createeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
      }
      data = JSON.stringify(data);

      setLoading(true);

      try {
        await axios({
          method: method,
          url: `${baseURL}${url}`,
          data: data,
          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          setLoading(false);
          if (response.data.success) {
            setSuccess(true);
            setRoomNoAndPhoneNo(roomNumber)
            settimeisValid(false);
            setSelectedTime('');
            setTimeout(() => {
              setSuccess(false);
              navigate("../order-history")
            }, 2000);
          } else {
            console.log(response?.data?.message)
            setErrorMsgValue(response?.data?.message);
            setSelectedTime('');
          }
        });
      } catch (error) {
        console.error(error);
        setError("axios");
        setLoading(false);
        settimeisValid(false);
        setSelectedTime('');
      }
     
      setLoading(false);
    
  };

  const handleMobile = (number) => {
    if (/^[0-9+-]*$/.test(number)) {
      setMobileNo(number);
    }
    setError("");
    setMobileValidation(validatePhoneNumber(number));
  };


  return (
    <div>
      <div className="relative dark-modal">
        <div
          style={{
            width: "100%",
            height: "150px",
            maxHeight: "200px",
            backgroundImage: `url(${props.spaData.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="absolute top-3 left-3">
          <BackButton whiteTheme={true}/>
        </div>
        <div className="section-wrap mx-4 pt-6">
          <div className="guestName sm:text-center text-left">Request</div>
          <div className="mt-6 text-base font-semibold">
            {props.spaData.serviceName}
            {RateFromPromotion === '' ? "": <p className="text-[14px]">{props.currencySymbol} {RateFromPromotion}</p>} 
          </div>
          <form onSubmit={handleSubmit} className="flex flex-col">
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Occupancy  
            </label>
            <div className="mt-2 relative flex items-center justify-between">
              {/* <div className="text-sm font-medium">{noOfPeople} Person</div> */}
              <input
                type="text"
                value={noOfPeople}
                onChange={handleOccupancyChange}
                className="reqInput"
              />
              <div className="flex  space-x-6 items-center absolute right-2">
              <div onClick={handleDecrment} className="cursor-pointer">
                  <img src={Decrement} />
                </div>
                <div onClick={handleIncrment} className="cursor-pointer">
                  <img src={Increment} />
                </div>
               
              </div>
            </div>
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred date
            </label>
            <input
              onChange={handleDate}
              className="mt-2 reqInput"
              type="date"
              value={date}
              min={initialDate}
              max={date_out}
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred Time
            </label>


            <Box sx={{ width: '100%' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <TimePicker
                 slotProps={{ textField: { placeholder: 'Please select the time' } }}
                    fullWidth
                    value={timeValue}
                    onChange={(val)=>handleTimeChange(val)}
                    // minTime={start_time} // Set min time
                    // maxTime={maxTime} // Set max time
                    placeholder="sdvbgsxdbgsed"
                    sx={{
                      '& .MuiInputBase-root': {
                        borderRadius: '4px',
                        background: '#342f4f',
                        outline: 'none',
                        padding: '10px 16px',
                        border: 'none',
                        color: '#fff',
                        width: '100%',
                      },
                      '& .MuiInputBase-input': {
                        padding: '0',
                        color: 'inherit',
                        borderRadius: '4px',
                      },
                      '& .MuiSvgIcon-root': {
                        color: '#fff',
                      },
                      '&.Mui-focused .MuiInputBase-root': {
                        borderColor: 'transparent',
                        boxShadow: 'none',
                      },
                      '&:hover .MuiInputBase-root': {
                        borderColor: 'transparent',
                      },
                    }}
                  /> 
                </Box>
              </LocalizationProvider>
            </Box>
           
             {isCheckedIn == "true" ? (
                  <>
                    <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                      Room Number
                    </label>
                    <input
                      onChange={handleRoomNo}
                      className="mt-2 reqInput"
                      type="text"
                      value={roomNumber}
                    />
                  </>
                ) : (
                  <>
                    <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                      Mobile No.
                    </label>
                    <input
                      onChange={(e) => handleMobile(e.target.value)}
                      value={mobileNo}
                      className="mt-2 reqInput"
                      type="text"
                    />
                    {/* {!mobileValidation && (
                      <span className="text-red-500 text-sm">
                        Invalid number
                      </span>
                    )} */}
                  </>
                )}

            {/* <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Comment if any
            </label>
            <textarea className="mt-2 reqInput" type="textarea" name="" id="" /> */}
            <button
              disabled={loading}
              className="bookBtn mt-8 relative"
            >
              <span> {location.state?.spadata ? "Update Booking":"Book Now"}</span>
              {loading && <ButtonLoader />}
            </button>
          </form >
        </div >
    <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
      {error == "validation" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
            {errorMsg ? errorMsg : "Please enter room number.."}
          </div>
        </div>
      )}
       
      {error == "axios" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
            Somthing went wrong.
          </div>
        </div>
      )}

      {error == "dateError" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
          Please select a date 
          </div>
        </div>
      )}
    
      {error == "OccupancyError" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
            Please choose a valid occupancy 
          </div>
        </div>
      )}
      {error == "timeIsnotSelect" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
          Please select a time 
          </div>
        </div>
      )}

      {error == "timeCheck" && (
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
           The spa is unavailable at the chosen time. Please check the working hours for more information.
          </div>
        </div>
      )}
      {errorMsg && errorMsg != "axios" && errorMsg != "timeCheck" &&
        <div className="w-full flex justify-center">
          <div className="error-doc text-center mt-3">
            {errorMsg}
          </div>
        </div>
      }
      {success && (
        <div className="w-full flex justify-center">
          <div className="success-doc text-center mt-3">
            Successfully booked
          </div>
        </div>
      )}
    </div>
      </div >
    </div >
  );
}

export default SpaForm;
